import sensediaCorp from './sensediaCorp'

const sensediaCorpAuth = {

  async requestSensediaCorpToken() {
    const auth = {
      headers: {'Content-Type':'application/x-www-form-urlencoded'}
    }
    const res = await sensediaCorp.client.post('/oauth/access-token?grant_type=client_credentials',{}, auth)
    return res.data
  },
  async repeatRequestSensedia(previousRequestPath, previousRequestParams, previousRequestType, headersMap) {
    if (previousRequestType === 'get') {
      return await sensediaCorp.client.get(previousRequestPath, {})
    }

    return await sensediaCorp.client.post(previousRequestPath, previousRequestParams, headersMap)
  },
}

export default sensediaCorpAuth



// WEBPACK FOOTER //
// ./src/services/state/middlewares/axios/clients/sensediaCorpAuth.js